<template>
    <v-dialog v-model="show" max-width="960px">
        <v-card v-if="show" :disabled="disabled">
            <v-card-title>
                <span v-if="popup?._id" class="tit tit--xs font-weight-bold">팝업수정</span>
                <span v-else class="tit tit--xs font-weight-bold">팝업추가</span>
            </v-card-title>
            <v-card-text>
                <v-row align="center" class="mt-0">
                    <v-col cols="12" class="pa-0">
                        <v-text-field v-model="popup.name" label="명칭" persistent-placeholder dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row align="center" class="mt-8">
                    <v-col cols="12" class="pa-0">
                        <v-text-field v-model="popup.no" label="순서" persistent-placeholder dense hide-details></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-8" align="center">
                    <v-col cols="12" class="pa-0">
                        <v-text-field v-model="popup.url" label="URL" persistent-placeholder dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" class="pa-0 pt-2">
                        <div class="warning--text"> ※ 사이트 내 페이지의 경우, <b>절대경로</b>로 입력하세요. <b>절대경로</b>는 문자열 맨 앞에 <code class="pa-1">/</code>를 포함하여야 합니다. </div>
                        <div class="warning--text"> ※ <code class="pa-1">/offerwall <span class="primary--text">(O)</span></code>, <code class="pa-1">offerwall <span class="error--text">(X)</span></code>, <code class="pa-1">https://daehanbooks.co.kr/offerwall <span class="error--text">(X)</span></code> </div>
                    </v-col>
                </v-row>
                <v-row class="mt-8" align="center">
                    <v-col cols="12" class="pa-0">
                        <v-select v-model="popup.code" :items="item" label="페이지" persistent-placeholder dense hide-details></v-select>
                    </v-col>
                </v-row>                    
                <v-row class="mt-8" align="center">
                    <v-col cols="6" class="py-0 pl-0"><v-text-field v-model="popup.left" label="위치(x)" persistent-placeholder dense hide-details></v-text-field></v-col>
                    <v-col cols="6" class="py-0 pr-0"><v-text-field v-model="popup.top" label="위치(y)" persistent-placeholder dense hide-details></v-text-field></v-col>
                </v-row>
                <v-row class="mt-8" align="center">
                    <v-col cols="6" class="py-0 pl-0"><v-text-field v-model="popup.width" label="크기(가로)" persistent-placeholder dense hide-details></v-text-field></v-col>
                    <v-col cols="6" class="py-0 pr-0"><v-text-field v-model="popup.height" label="크기(세로)" persistent-placeholder dense hide-details></v-text-field></v-col>
                </v-row>
                <v-row class="mt-8" align="center">
                    <v-col cols="auto" class="pa-0">전시여부</v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="pa-0">
                        <v-switch v-model="popup.display.enabled" dense hide-details class="ma-0 pa-0"></v-switch>
                    </v-col>
                </v-row>
                <v-row class="mt-8" align="center">
                    <v-col cols="auto" class="pa-0">전시기간</v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="pa-0">
                        <v-switch v-model="popup.display.period" dense hide-details class="ma-0 pa-0"></v-switch>
                    </v-col>
                </v-row>
                <v-row v-if="popup.display.period" class="mt-6" align="center">
                    <v-col cols="6" class="py-0 pl-0">
                        <v-menu ref="startDateMenu" :close-on-content-click="false" :return-value.sync="popup.display.startDate" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="popup.display.startDate" label="주문일자" persistent-placeholder dense hide-details append-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="popup.display.startDate" no-title scrollable @input="$refs.startDateMenu.save(popup.display.startDate)"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="6" class="py-0 pr-0">
                        <v-menu ref="endDateMenu" :close-on-content-click="false" :return-value.sync="popup.display.endDate" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="popup.display.endDate" label="주문일자" persistent-placeholder dense hide-details append-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="popup.display.endDate" no-title scrollable @input="$refs.endDateMenu.save(popup.display.endDate)"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row class="mt-6">
                    <v-col class="pa-0">
                        <naver-smarteditor v-model="popup.content"></naver-smarteditor>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close">취소</v-btn>
                <v-btn text color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
export default {
    components: {
        NaverSmarteditor
    },
    props: {
        disabled: { type: Boolean, default: false },
    },
    data: () => {
        return {
            showSearch: true,

            page: 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            popups: [],
            popupsHeaders: [
                {
                    text: '순서',
                    width: 100,
                    align: 'center',
                    value: 'sequence'
                },
                {
                    text: '명칭',
                    width: 200,
                    align: 'center',
                    value: 'name'
                },
                {
                    text: 'URL',
                    align: 'center',
                    value: 'url'
                },
                {
                    text: '전시여부',
                    align: 'center',
                    width: 140,
                    value: 'display.enabled'
                },
                {
                    text: '등록일자',
                    align: 'center',
                    width: 140,
                    value: 'createdAt'
                },
                {
                    text: 'actions',
                    align: 'center',
                    width: 100,
                    value: 'actions'
                }
            ],

            show: false,
            popup: null,
            defaultItem: {
                _id: null,
                code: null,
                subject: null,
                content: null,
                url: null,

                left: 0,
                top: 0,
                width: 0,
                height: 0,

                display: {
                    enabled: false,
                    period: false,
                    startDate: null,
                    endDate: null
                }
            },

            image: null,
            item:[
                { text: "메인페이지", value: "main" },
                { text: "상품권페이지", value: "gshop" }
            ]
        };
    },
    created(){
        this.popup = JSON.parse(JSON.stringify(this.defaultItem))
    },
    methods: {
        close() {
            this.show = false;
        },

        async open(){
            this.show = true;
        },

        async save() {
            this.popup._id ? await api.console.common.popups.put(this.popup) : await api.console.common.popups.post(this.popup);
            this.close();
        },
    },
    watch: {
        show(){
            if(!this.show) this.$emit("close");
        }
    }
}
</script>